import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import Header from "../components/layouts/Header";
import styles from "../styleBlog/cssBlog/style.css";
import MeiliSearch from "meilisearch";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import InfiniteScroll from "react-infinite-scroll-component";
import { getStrapiURL } from "../lib/api";

const LIMIT = 15;

function Blog({ blogData }) {
  const {
    title,
    date,
    content,
    urlTitle,
    tag: { label },
    avatar: { url },
    id,
  } = blogData;

  let author =
    typeof blogData.author === String
      ? blogData.author
      : blogData.author?.username;

  return (
    <div className="dlab-blog style-1 bg-white text-center m-b50" key={id}>
      <div className="dlab-media dlab-img-effect zoom">
        <img src={getStrapiURL(url)} alt="" />
      </div>
      <div className="dlab-info">
        <h4 className="dlab-title">
          <Link to={"/blog/" + id + "/" + urlTitle}>{title}</Link>
        </h4>
        <p className="m-b0">{content.substring(0, 100)}</p>
        <div className="dlab-meta meta-bottom">
          <ul>
            <li className="post-date">
              <i className="flaticon-clock m-r10"></i>
              <Moment format="DD-MM-YYYY HH:mm:ss">{date}</Moment>
            </li>
            <li className="post-author">
              <i className="flaticon-user m-r10"></i>
              {author}
            </li>
            <li className="post-comment">
              <a href="javascript:void(0);">
                <i className="flaticon-speech-bubble"></i>
                <span>15</span>
              </a>
            </li>
            <li className="post-share">
              <i className="flaticon-share"></i>
              <ul>
                <li>
                  <a
                    className="fa fa-facebook"
                    href="https://en-gb.facebook.com/"
                  ></a>
                </li>
                <li>
                  <a
                    className="fa fa-twitter"
                    href="https://twitter.com/login?lang=en"
                  ></a>
                </li>
                <li>
                  <a
                    className="fa fa-linkedin"
                    href="https://www.linkedin.com/login"
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function BlogLargeRightSidebar() {
  const [articles, setArticles] = useState([]);
  const [articlesFiltered, setArticlesFiltered] = useState([]);
  const [query, setQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [hasNextPage, setHasNextPage] = useState(true);
  const [offset, setOffset] = useState(0);
  const [lastPage, setLastPage] = useState({});
  const [tagCount, setTagCount] = useState([]);
  const [client, setClient] = useState(new MeiliSearch({
    host: `https://ms-1c797c9ae5e4-1391.lon.meilisearch.io`,
    apiKey:
      "691da4cb805ad75d2ee862188c9cecaf4cd88ad31825e900c1bd4662055aeb39",
  }));

  const fetchData = async () => {
    const index = await client.getIndex("article");
    const articleData = await index.search("*", {
      limit: LIMIT,
      offset: offset,
    });

    console.log("articles alltop ", articleData.hits);
    if (offset >= LIMIT) {
      setArticles([...articles, ...articleData.hits]);
    } else {
      setArticles(articleData.hits);
    }
    setLastPage(articleData);

    try {
      let url = getStrapiURL("/api/tags/article/count");
      const res = await axios.get(url);
      console.log("tag and count", res.data);
      setTagCount(res.data);
    } catch (error) {
      console.log("error ", error);
    }
  };

  const fetchFilteredData = async () => {
    setOffset(0);
    const index = await client.getIndex("article");
    const articleD = await index.search(query, {
      limit: 2,
      offset: offset,
    });
    setArticlesFiltered([...articlesFiltered, ...articleD.hits]);
    setLastPage(articleD);
  };

  function dataHasNextPage(data) {
    if (data.length < lastPage.nbHits) {
      setHasNextPage(true);
    } else {
      setHasNextPage(false);
    }
  }

  useEffect(() => {
    if (!articlesFiltered) {
      setOffset(articles.length);
      dataHasNextPage(articles);
    } else {
      setOffset(articlesFiltered.length);
      dataHasNextPage(articlesFiltered);
    }
  }, [articles]);

  useEffect(() => {
    if (query.length > 0) {
      fetchSearchArticlesData();
    } else {
      fetchData();
    }
  }, [query]);

  const fetchSearchArticlesData = async () => {
    setOffset(0);
    const index = await client.getIndex("article");
    const articleData = await index.search(query);

    setArticlesFiltered(articleData.hits);

    setLastPage(articleData);
  };

  useEffect(() => {
    setOffset(0);
    const searchMethod = async () => {
      try {
        let url = getStrapiURL("/api/articles/filter/" + searchQuery + "/details");

        const res = await axios.get(url);
        console.log("new filter d", res.data);
        setArticlesFiltered(res.data);
      } catch (error) {
        console.log("error bigogo", error);
      }
    };
    if (!!searchQuery) {
      searchMethod();
    } else if(searchQuery.length===0) {
      setArticlesFiltered([]);
    }
  }, [searchQuery]);

  const [toggleMenu, setToggleMenu] = useState(false);

  const headerToggler = (e) => {
    e.preventDefault();
    setToggleMenu(!toggleMenu);
  };

  document.addEventListener("click", function (e) {
    if (e.target.closest(".content")) {
      setToggleMenu(false);
    }
  });

  return (
    <>
      <Header
        logoSource="/images/yabsLogoWhite.png"
        toggleMenu={toggleMenu}
        headerToggler={headerToggler}
      />
      <main className={toggleMenu ? "content open" : "content"}>
        <div className="spacer" data-height="90"></div>
        <div className="blog-page-section">
          <div className="container">
            <div className="page-content bg-white">
              {/* <!-- Banner  --> */}
              <div
                style={{
                  backgroundImage: "url(images/bnr2.jpg)",
                  backgroundColor: "#353353",
                }}
              >
                <div className="container">
                  <div className="dlab-bnr-inr-entry ">
                    <h1 className="" style={{ color: "#fff" }}>
                      Blog du dev
                    </h1>
                    {/* <!-- Breadcrumb Row --> */}
                    <nav aria-label="breadcrumb">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          <a href="/">Accueil</a>
                        </li>
                        <li
                          className="breadcrumb-item active"
                          aria-current="page"
                        >
                          Blog
                        </li>
                      </ul>
                    </nav>
                    {/* <!-- Breadcrumb Row End --> */}
                  </div>
                </div>
              </div>
              {/* <!-- Banner End --> */}

              {/* <!-- Blog Large --> */}
              <section
                className="content-inner bg-img-fix"
                style={{ backgroundImage: "url(images/bg1.png)" }}
              >
                <div className="container">
                  <div className="row">
                    <div
                      className="col-xl-8 col-lg-8 m-b50"
                      style={{ overflowY: "scroll" }}
                    >
                      <div
                        id="scrollableDiv"
                        style={{
                          height: "95%",
                          overflow: "auto",
                          display: "flex",
                        }}
                      >
                        <InfiniteScroll
                          dataLength={articles.length} //This is important field to render the next data
                          next={fetchData}
                          hasMore={hasNextPage}
                          loader={<h4>Chargement...</h4>}
                          endMessage={
                            <p style={{ textAlign: "center" }}>
                              <b>Yay! Vous avez tout vu</b>
                            </p>
                          }
                          // below props only if you need pull down functionality
                          refreshFunction={fetchFilteredData}
                          pullDownToRefresh
                          pullDownToRefreshThreshold={50}
                          pullDownToRefreshContent={
                            <h3 style={{ textAlign: "center" }}>
                              &#8595; Tirez vers le bas pour rafraîchir
                            </h3>
                          }
                          releaseToRefreshContent={
                            <h3 style={{ textAlign: "center" }}>
                              &#8593; Relachez pour rafraîchir
                            </h3>
                          }
                        >
                          {(query != null &&
                            query != "" &&
                            !!articlesFiltered) ||
                          (searchQuery.length > 0 && articlesFiltered.length > 0)
                            ? articlesFiltered?.map((article) => (
                                <Blog blogData={article} />
                              ))
                            : articles?.map((article) => (
                                <Blog blogData={article} />
                              ))}
                        </InfiniteScroll>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 m-b30">
                      <aside className="side-bar sticky-top">
                        <div className="widget">
                          <div className="search-bx">
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text" style={{marginTop: '40%'}}>
                                  <i className="la la-search"></i>
                                </span>
                              </div>
                              <input
                                name="query"
                                className="form-control"
                                placeholder="Rechercher..."
                                type="text"
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="widget widget_archive">
                          <h2 className="widget-title">Catégories</h2>
                          <ul>
                            <li>
                              <a onClick={() => setSearchQuery("")}>{"Tout"}</a>
                            </li>
                            {tagCount?.map((tag) => (
                              <li>
                                <a onClick={() => setSearchQuery(tag.label)}>
                                  {tag.label}
                                  <span>{tag.count}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </aside>
                    </div>
                  </div>
                </div>
              </section>

              {/* <!-- Call To Action --> */}
              <section
                style={{
                  backgroundImage: "url(images/bg5.jpg)",
                  backgroundSize: "cover",
                }}
              >
                <div className="container">
                  <div className="row action-box style-1 align-items-center">
                    <div
                      className="col-xl-7 col-lg-8 col-md-8 wow fadeIn"
                      data-wow-duration="2s"
                      data-wow-delay="0.2s"
                    >
                      <div className="section-head style-1">
                        <h6 className="sub-title bgl-primary m-b20 text-primary">
                          Allez plus loin
                        </h6>
                        <h2 className="title">
                          Vous voulez le top pour votre site et un marketing
                          digital efficace.
                        </h2>
                      </div>
                    </div>
                    <div
                      className="col-xl-5 col-lg-4 col-md-4 text-right m-b30 wow fadeIn"
                      data-wow-duration="2s"
                      data-wow-delay="0.4s"
                    >
                      <a
                        href="#"
                        className="btn btn-link d-inline-flex align-items-center"
                      >
                        <i className="fa fa-angle-right m-r10"></i>
                        Rejoingnez-moi
                      </a>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default BlogLargeRightSidebar;
